import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import { useTranslation } from 'react-i18next';
import CreateFuelTypeForm from '../../../modules/fuelTypes/components/CreateFuelTypeForm';
import { useParams } from 'react-router-dom';

const CreateFuelType = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const title = id ? t('edit_fuel_type') : t('create_fuel_type');
  dispatch(
    setBreadCrumbsData({
      links: [{ label: title, path: '/fuel-types/create-fuel-type' }],
      page_title: title
    })
  );

  return (
    <div>
      <CreateFuelTypeForm />
    </div>
  );
};

export default CreateFuelType;
